import CheckIcon from '@icons/Check.svg';
import Remove from '@icons/Remove.svg';
import classNames from 'classnames';

type Size = 'small' | 'medium';

export interface Props {
  /**
   * Checked
   */
  checked: boolean;
  /**
   * Hover
   */
  hover?: boolean;
  /**
   * Focused
   */
  focus?: boolean;
  /**
   * Size
   */
  size?: Size;
  /**
   * Variant
   */
  variant?: 'regular' | 'intermidiate';
  /**
   * ClassName
   */
  className?: string;
}

export const Checkbox = ({
  checked,
  hover = false,
  focus = false,
  size = 'medium',
  variant = 'regular',
  className,
}: Props) => {
  const iconClassName = classNames('text-secondary-softlight', {
    'size-4': size === 'small',
    'size-5': size === 'medium',
  });

  const stateColorClasses = (() => {
    if (hover) {
      return 'border-secondary-softlight bg-surface-medium';
    }
    if (focus) {
      return 'border-secondary-softlight bg-surface-dark';
    }
    return 'border-secondary-softlight-700 bg-surface-dark';
  })();

  return (
    <span
      className={classNames(
        'relative flex items-center justify-center',
        'rounded-xs border',
        'transition-colors duration-200',
        stateColorClasses,
        {
          'size-4': size === 'small',
          'size-5': size === 'medium',
        },
        className,
      )}
    >
      {checked &&
        (variant === 'intermidiate' ? <Remove className={iconClassName} /> : <CheckIcon className={iconClassName} />)}
    </span>
  );
};
